import React from "react";
import { useTranslation } from 'react-i18next';

const MoreAboutHealth = () => {
	const { t } = useTranslation();

	return (
		<>
			<div className="content px-2">
				<div className="get-quote-process-container vw-50">
					<div className="d-flex w-100">
						<div className="d-flex flex-column">
							<h3 className="mb-2">{t(`moreAboutAnsa.title`)}</h3>
							<div className="d-flex flex-row align-items-center vw-100">
								<span className="color-heading fw-bold my-2">
									{t(`moreAboutAnsa.subTitle`)}
								</span>
							</div>

							<ol className="px-4 m-0">
								<li className="text-justify formatted-text my-3">{t(`moreAboutAnsa.abouts.1`)}</li>
								<li className="text-justify formatted-text my-3">{t(`moreAboutAnsa.abouts.2`)}</li>
								<li className="text-justify formatted-text my-3">{t(`moreAboutAnsa.abouts.3`)}</li>
								<li className="text-justify formatted-text my-3">{t(`moreAboutAnsa.abouts.4`)}</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default MoreAboutHealth;